// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  VisibilityOffRounded,
  VisibilityRounded,
} from '@/constants/hardfin-standard-icons';
import { IconProps } from '@mui/material';

const DEFAULT_FONT_SIZE = 'small';
const DEFAULT_COLOR = 'inherit';

interface Props extends Pick<IconProps, 'fontSize' | 'color'> {
  /**
   * If true, the "archived" icon will be rendered.
   */
  isArchived: boolean;
}

/**
 * Renders an icon representing whether an entity is archived.
 */
export function ArchivedIcon(props: Props) {
  const color = props.color ?? DEFAULT_COLOR;
  const fontSize = props.fontSize ?? DEFAULT_FONT_SIZE;

  if (props.isArchived) {
    return <VisibilityOffRounded fontSize={fontSize} color={color} />;
  }

  return <VisibilityRounded fontSize={fontSize} color={color} />;
}
